(function() {
  let debounceTimer = null;

  function updateCartCount(count) {
    document.querySelectorAll('.cart-bubble__text-count').forEach(el => {
      el.textContent = count;
    });
    document.querySelectorAll('.cart-bubble__text .visually-hidden').forEach(el => {
      el.textContent = `Total items in cart: ${count}`;
    });
    document.querySelectorAll('cart-icon').forEach(icon => {
      if (count > 0) {
        icon.classList.add('header-actions__cart-icon--has-cart');
        icon.querySelector('.cart-bubble')?.classList.remove('visually-hidden');
        icon.querySelector('.cart-bubble__text-count')?.classList.remove('hidden');
      } else {
        icon.classList.remove('header-actions__cart-icon--has-cart');
        icon.querySelector('.cart-bubble')?.classList.add('visually-hidden');
        icon.querySelector('.cart-bubble__text-count')?.classList.add('hidden');
      }
    });
  }

  function debouncedFetch() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(async () => {
      try {
        const cart = await (await fetch('/cart.js')).json();
        updateCartCount(cart.item_count);
      } catch (e) {}
    }, 500);
  }

  document.addEventListener("cart:updated", debouncedFetch);

  const origXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    this._mcUrl = url;
    return origXHROpen.call(this, method, url, ...rest);
  };
  const origXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function(...args) {
    this.addEventListener('load', function() {
      if (this._mcUrl && /\/cart\/(add|change|update|clear)/.test(this._mcUrl)) {
        setTimeout(debouncedFetch, 100);
      }
    });
    return origXHRSend.apply(this, args);
  };
})();
